/**
 * The fields an account's display name is derived from. Structural for the same reason as
 * LinkedAccountPaymentFields.
 */
export interface LinkedAccountDisplayFields {
    nickname?: string | null;
    accountTypeName?: string | null;
}

/**
 * What to call a linked account. A nickname is optional, so the account type names the account
 * whenever the user has not.
 *
 * Shared rather than derived per view: the card heading, both portals' table account columns
 * and the unlink confirmations all name the same account.
 */
export function linkedAccountDisplayName(account: LinkedAccountDisplayFields): string {
    return account.nickname || account.accountTypeName;
}
